import PotencialClientList from '../PotencialClient/PotencialClientList';

export const PreapprovedClient: object = {
  list: PotencialClientList,
};

export default PreapprovedClient;
